import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api, { mediaUrl } from "@/lib/api";
import useSeo, { CANONICAL_BASE } from "@/lib/useSeo";

export function LookbookList() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/lookbooks").then(({ data }) => setItems(data)).catch(() => {}); }, []);
  useSeo({ title: "Lookbook — ONUSA", description: "ONUSA campaign lookbooks and editorial stories.", canonical: CANONICAL_BASE + "/lookbook" });
  return (
    <div className="onusa-container py-12 md:py-20" data-testid="lookbook-list-page">
      <p className="label-x">EDITORIAL</p>
      <h1 className="heading-x text-3xl md:text-5xl mt-2 mb-10">LOOKBOOK</h1>
      <div className="grid md:grid-cols-2 gap-6 md:gap-10">
        {items.map((lb) => (
          <Link key={lb.id} to={`/lookbook/${lb.slug}`} className="group block" data-testid={`lookbook-${lb.slug}`}>
            <div className="aspect-[4/5] overflow-hidden bg-[#E8E1D8]">
              <img src={mediaUrl(lb.cover)} alt={lb.title} className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-700" />
            </div>
            <h2 className="heading-x text-xl mt-4">{lb.title}</h2>
          </Link>
        ))}
        {items.length === 0 && <p className="label-x">NOG GEEN LOOKBOOKS</p>}
      </div>
    </div>
  );
}

export function LookbookDetail() {
  const { slug } = useParams();
  const [lb, setLb] = useState(null);
  useEffect(() => { api.get(`/lookbooks/${slug}`).then(({ data }) => setLb(data)).catch(() => {}); }, [slug]);
  useSeo(lb ? { title: `${lb.title} — ONUSA`, canonical: CANONICAL_BASE + "/lookbook/" + lb.slug, image: mediaUrl(lb.cover) } : {});
  if (!lb) return <div className="onusa-container py-32"><div className="aspect-video bg-[#E8E1D8] animate-pulse" /></div>;
  return (
    <div data-testid="lookbook-detail-page">
      <div className="relative h-[70vh] min-h-[420px] overflow-hidden">
        <img src={mediaUrl(lb.cover)} alt={lb.title} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#1D1D1B]/30 flex items-end">
          <div className="onusa-container pb-14"><h1 className="heading-x text-[#F7F5F1] text-4xl md:text-6xl">{lb.title}</h1></div>
        </div>
      </div>
      <div className="onusa-container py-16 space-y-10 max-w-4xl">
        {(lb.blocks || []).map((b, i) => (
          <div key={i}>
            {b.type === "image" && <div className="overflow-hidden bg-[#E8E1D8]"><img src={mediaUrl(b.image)} alt={b.caption || ""} className="w-full object-cover" />{b.caption && <p className="label-x mt-3 text-center">{b.caption}</p>}</div>}
            {b.type === "text" && <div className="text-center py-8"><h2 className="heading-x text-2xl md:text-4xl">{b.heading}</h2>{b.body && <p className="mt-4 text-[#77736D]">{b.body}</p>}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
